@if (isDescriptionVisible()) {
  <ui-form-description-panel [description]="description()"></ui-form-description-panel>
}

<ui-form-description-toggle
  [(open)]="isDescriptionVisible"
  [alignment]="alignment()"
></ui-form-description-toggle>
